module.exports = "<footer class=\"app-footer\">\n    <!--<span><a href=\"https://genesisui.com\">Alba</a> &copy; 2017 creativeLabs.</span>-->\n    <span class=\"ml-auto\">Powered by <a href=\"#\">Achieve Safety</a> | <a class=\"txt1\" [routerLink]=\"['/privacy-policy']\"> Privacy Policy </a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main